import { AccountMenu } from '@/components/Login'
import { CopyQuotesLinkButton } from '@/components/quotes/CopyQuotesLinkButton'
import { ProductFlowNav } from '@/routes/Public/marketing/components/ProductFlowNav'
import { DEMO_APPLICATION_ID, MATCHED_BROKER } from './navFixtures'

/** ProductFlowNav's account menu with a stand-in user; Sign out does nothing, so viewers keep their session. */
export function AccountMenuNavDemo() {
  return (
    <ProductFlowNav
      disableScrollHide
      hideLogin
      accountMenu={
        <AccountMenu
          name="Jim Mitchell"
          email="jim@bluelinefreight.com"
          trigger="menu"
          onSignOut={() => undefined}
        />
      }
      matchedBroker={MATCHED_BROKER}
      allowBrokerNote
      cartCount={2}
      rightAction={<CopyQuotesLinkButton applicationId={DEMO_APPLICATION_ID} />}
    />
  )
}
